export const providersKeys = {
  providers: "/public/providers",
};
